module.exports = __webpack_public_path__ + "static/img/pixfiv.a11c30b5.png";